import axios from "../axios-auth";

export const shopService = {
  getAllShop,
  getShopList,
  getShopById,
  saveShop,
  getShopByNameCode,
  getShopBinList,
};
function getShopList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };

  if (searchParams.name) {
    params["name"] = searchParams.name;
  }
  if (searchParams.code) {
    params["code"] = searchParams.code;
  }
  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }
  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  return axios.get("/auth/all-shop", { params });
}

function getAllShop() {
  return axios.get("auth/shops");
}

function getShopById(id) {
  return axios.get("auth/shop/" + id);
}

function saveShop(shop) {
  if (!shop.id) {
    // new brand
    return axios.post("/auth/shop", shop);
  } else {
    // edit
    return axios.put("/auth/shop", shop);
  }
}

function getShopByNameCode(searchParams) {
  let params = {};

  if (searchParams.nameCode) {
    params["nameCode"] = searchParams.nameCode
  }

  return axios.get("/auth/shop-by-name-code", { params })
}

function getShopBinList(id) {
  return axios.get("/auth/shop-bins/" + id);
}

